var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAffiliateProgramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#559EA3",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.884 6.483.754-.753a.352.352 0 1 0-.498-.497l-.753.753a.352.352 0 1 0 .497.497Zm1.635 1.66h-.753a.352.352 0 1 0 0 .702h.753a.352.352 0 1 0 0-.703Zm-4.143-2.687a.352.352 0 0 0 .352-.351v-.753a.352.352 0 0 0-.703 0v.753c0 .194.157.351.351.351Zm-6.273 7.308a.352.352 0 0 0 0 .497l1.506 1.506c.137.138.36.138.497 0l.59-.589-2.004-2.003-.59.589Zm6.087.284L8.72 14.21l1.688 1.687c.137.137.36.137.497 0l1.318-1.318a.352.352 0 0 0 0-.497l-1.034-1.034ZM9.742 5.233a.352.352 0 0 0-.566.099l-2.987 6.346 2.004 2.003 6.346-2.986a.353.353 0 0 0 .099-.567L9.742 5.233Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateProgramIcon);
export default __webpack_public_path__ + "static/media/affiliate-program-icon.e9c8d39f6d3540ebc1e13096f74e088e.svg";
export { ForwardRef as ReactComponent };